<template>
	<div class="tag" :class="customClass">
		<span v-if="title">{{ title }}:</span>{{ value }}
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
		},
		value: {
			type: String,
		},
		priority: {
			type: Boolean,
		},
		customClass: {
			type: String,
		},
	},
}
</script>

<style lang="scss" scoped>
.tag {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 4px 16px;
	gap: 4px;
	background: #535353;
	border-radius: 5px;
	width: 100%;
	font-size: 12px;
	line-height: 15px;
	color: #fff;
	font-family: var(--head-bold);
	&.featured {
		color: var(--btn-featured-text-color);
		background-color: var(--btn-featured-bg-color);
	}
}
@media (min-width: 768px) {
	.tag {
		height: 31px;
		padding: 5px 16px 4px;
		font-size: 16px;
		line-height: 20px;
	}
}
</style>
